import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Driver } from '../models/Driver';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MovementsService {
  url = environment.apiUrl;
  xigaMovil = environment.xigaMovil;

  constructor(private http: HttpClient) {}

  getDriver(clientId: number, cardId: number): Observable<any> {
    let params = '?clientId=' + clientId + '&cardId=' + cardId;
    return this.http.get<any>(this.url + 'Movements/driver' + params);
  }

  saveDriver(driver: Driver[]): Observable<Driver[]> {
    return this.http.post<Driver[]>(this.url + 'Movements/driver', driver);
  }

  deleteDriver(drivers: any[]): Observable<any> {
    const url = `${this.url}Movements/driver`;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: drivers,
    };
    return this.http.request<any>('delete', url, options);
  }

  getDriverTable(cardId: number, clientId: number): Observable<any> {
    let params = '?cardId=' + cardId + '&clientId=' + clientId;
    return this.http.get<any>(this.url + 'Movements/driverTable' + params);
  }

  getGroup(clientId: number): Observable<any> {
    let params = '?clientId=' + clientId;
    return this.http.get<any>(this.url + 'Movements/group' + params);
  }

  getStation(data: any): Observable<any> {
    const params =
      '?clientNumber=' +
      data.clientNumber +
      '&clientId=' +
      data.clientId +
      '&type=' +
      data.type +
      '&id=' +
      data.id;
     
    return this.http.get<any>(this.url + 'Movements/station' + params);
  }

  deleteStation(data: any): Observable<any> {
    const url = `${this.url}Movements/station`;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: data,
    };
    return this.http.request<any>('delete', url, options);
  }

  saveStation(data: any[]): Observable<any[]> {
    return this.http.post<any[]>(this.url + 'Movements/station', data);
  }

  getConsumptionsByGmcId(
    cardId: number,
    version: string,
    token: string
  ): Observable<any> {
    /*if (environment.isTest) {
      return of([{
        consumptionId: 1001, expirationDate: new Date(Date.now() + 3600000).toISOString(),
        status: 1, folio: "TEST-001", description: "QR Test", comments: "Dev test",
        isVolume: 1, fuelQuantity: 20, fuelAmount: 500
      }]);
    }*/
    const headers = new HttpHeaders({ Authorization: 'Bearer ' + token });
    const url =
      `${this.xigaMovil}padlock/api/client/getConsumptionsByGmcId/` +
      cardId +
      '?version=' +
      version;
    return this.http.get(url, { headers: headers });
  }

  getCurrentCardBalance(
    fullCardNumber: string,
    token: string
  ): Observable<any> {
    /*if (environment.isTest) {
      return of({
        cardId: 9999, gasoline: "123",
        odometerValidations: { validateOdometerLecture: false, odometerLectureLimit: 9999, lastReportedOdometer: 0 }
      });
    }*/
    const headers = new HttpHeaders({ Authorization: 'Bearer ' + token });
    const url = `${this.xigaMovil}padlock/api/station/authorize`;
    const data = {
      stationNUmber: 2685,
      dispenserProtocol: 'BENET',
      km: 123,
      mode: 'C',
      nip: 123,
      pumpNumber: 1,
      reference: fullCardNumber,
    };
    return this.http.post(url, data, { headers: headers });
  }

  GetDataCode(RequestObj: any, token: string): Observable<any> {
    /*if (environment.isTest) {
      return of({
        consumptionId: Math.floor(Math.random() * 9000) + 1000,
        consumptionIdentifier: "TEST-" + Date.now(),
        expirationDate: new Date(Date.now() + 3600000).toISOString(),
        message: "QR generado (test)"
      });
    }*/
    const headers = new HttpHeaders({ Authorization: 'Bearer ' + token });
    const url = `${this.xigaMovil}padlock/api/client/consumption/purse/save/auth`;
    return this.http.post(url, RequestObj, { headers: headers });
  }

  CancelQRConsumption(consumptionId: number, token: string): Observable<any> {
    if (environment.isTest) {
      return of({ isSuccess: true, message: "Cancelado (test)" });
    }
    const headers = new HttpHeaders({ Authorization: 'Bearer ' + token });
    const url =
      `${this.xigaMovil}padlock/api/client/consumption/update/` +
      consumptionId +
      '/4';
    return this.http.get(url, { headers: headers });
  }

  SendCodeByWhatsAppV2(RequestObj: any): Observable<any> {
   
    const url = `${this.url}consumption/web/reference/generate`;
    return this.http.post(url, RequestObj);
  }

  GetDetailEncryptedConsumption(reference: string): Observable<any> {
    if (environment.isTest) {
      return of({
        isSuccess: true, consumption_id: 1879290,
        consumption_identifier: "TEST-" + Date.now(),
        expiration_date: new Date(Date.now() + 1800000).toISOString(),
        vehicle: "17", amount_requested: 200, quantity_requested: 18902,
        is_volume: false, client_number: 15, product_name: "Supreme +", product_id: 2,
        message: ""
      });
    }

    let url = this.xigaMovil+'padlock/generatewebconsumption';
    return this.http.post<any>(url,{

      consumptionIdentifier:reference,  
    });
  }

  LoadSecureConsumption(secureIdentifier: string): Observable<any> {
    const url = this.url+'consumption/identificador/seguro'
    const data = {
        code:0,
        secureIdentifier: secureIdentifier,        
    };    
    return this.http.post<any>(url,data);
  }

  saveDevices(card: any[]): Observable<any[]> {
    return this.http.post<any[]>(this.url + 'Movements/group', card);
  }

  GetAuthClientTemporalCode(clientNumber:number): Observable<any> {
   
    const url = `${this.url}consumption/web/reference/auth?clientNumber=${clientNumber}`;
    return this.http.get(url);
  }
}
